import { PdpContextKey } from './context'

export const usePdp = () => {
  const data = inject(PdpContextKey)!

  if (!data) log.warn('usePdp() should be used inside a PDP page')

  return data
}
